<template>
  <div class="c-app">
    <Header />
    <router-view />
    <UserLoading v-if="loading" />
  </div>
</template>

<script>
import Header from "../commons/HeaderGuest";
import UserLoading from "../commons/Loading";
import { mapState } from "vuex";

export default {
  name: "GuestLayout",
  metaInfo() {
    return {
      title: "",
      titleTemplate: "株式会社 Fabbi"
    };
  },
  components: {
    Header,
    UserLoading
  },

  computed: {
    ...mapState("layout", {
      loading: state => state.loading
    })
  }
};
</script>

<style lang="scss">
@import "@/styles/auth.scss";
</style>
